import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SaberRolService {

  constructor() { }

  saberRol(getfactura: any, usuarioId: number): string {
    // Verificamos si el usuario es un supervisor
    if(usuarioId !== null){
      if (getfactura.FKId_Supervisor === usuarioId) {
        return 'Supervisor';
      }
    
      // Si el ID del administrador no es 74, solo hay un administrador
      if (getfactura.FKId_Administrador !== 74) {
        // Verificamos si el único administrador es el usuario actual
        if (getfactura.FKId_Administrador === usuarioId) {
          return 'Administrador de proyecto';
        }
      } else {
        // Si el ID del administrador es 74, hay múltiples administradores
        let todosAdministradores = getfactura.FKId_Administradores.split(',').map((id: string) => parseInt(id.trim()));
        // Comprobamos si el usuario actual está en la lista de administradores
        if (todosAdministradores.includes(usuarioId)) {
          return 'Administrador de proyecto';
        }
      }
      
      return 'Otro rol';
    
    }
    
    // Si no entra en ninguna de las validaciones anteriores, devolvemos "Otro rol"
    return 'Otro rol';
  }  

}
